import { tips } from "@/mocks/tips";

const bubble = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-700",
];

export default function Tips() {
  return (
    <section id="tips" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div className="max-w-xl">
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1 text-sm font-medium text-primary-700">
            阅读小贴士
          </span>
          <h2 className="mt-4 text-2xl font-black text-foreground-950 md:text-4xl">
            用好这些小技巧，阅读更顺畅
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
            除了解决问题，掌握几个常用技巧，能让笔笔漫画网的体验更稳定、更高效。
          </p>
        </div>
        <span className="hidden items-center gap-2 text-sm text-foreground-600 sm:flex">
          <i className="ri-lightbulb-flash-line text-lg text-secondary-500" />
          来自老读者的实用经验
        </span>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {tips.map((t, i) => (
          <div
            key={t.id}
            className="group rounded-2xl border border-background-200 bg-background-50 p-6 transition-all hover:border-secondary-300 hover:shadow-soft"
          >
            <div className="flex items-center justify-between">
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-xl text-2xl ${bubble[i % bubble.length]}`}
              >
                <i className={t.icon} />
              </span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                {t.tag}
              </span>
            </div>
            <h3 className="mt-5 text-lg font-bold text-foreground-950">{t.title}</h3>
            <p className="mt-2 text-sm leading-6 text-foreground-600">{t.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}